__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "container";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@shared", "2.7.0", () => (Promise.all([__webpack_require__.e(551), __webpack_require__.e(493), __webpack_require__.e(316), __webpack_require__.e(802), __webpack_require__.e(567)]).then(() => (() => (__webpack_require__(3844))))));
			register("@tanstack/react-query", "5.101.2", () => (Promise.all([__webpack_require__.e(980), __webpack_require__.e(316), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(8980))))));
			register("react-dom", "19.2.4", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(961)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(316), __webpack_require__.e(802)]).then(() => (() => (__webpack_require__(2648))))));
			register("react", "19.2.4", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			initExternal(5886);
			initExternal(4220);
			initExternal(8786);
			initExternal(5488);
			initExternal(9335);
			initExternal(1488);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};